import React from 'react';
import { animated, config, useTransition } from '@react-spring/web';

import { useDrawState } from '../hooks/use-draw-state';

export default function Users() {
  const { spectators, users } = useDrawState();
  const numPlayers = Object.keys(users).length ?? 0;
  const numViewers = spectators - numPlayers;

  const transitions = useTransition(
    Object.keys(users).map((id) => users[id]),
    {
      keys: Object.keys(users),
      config: config.wobbly,
      from: {
        transform: `scale3d(0,0,1)`,
        opacity: 0,
      },
      enter: {
        transform: `scale3d(1,1,1)`,
        opacity: 1,
      },
      leave: {
        transform: `scale3d(0,0,1)`,
        opacity: 0,
      },
    }
  );

  return (
    <div className="users">
      <span className="user">
        <i className={`fas fa-user`}></i>
        {` ${numPlayers}`}
        <i className={`fas fa-eye`} style={{ marginLeft: '0.5rem' }}></i>
        {` ${numViewers}`}
      </span>
      {transitions((style, item) => (
        <animated.span
          className="user"
          style={{ backgroundColor: item.color, ...style }}
        >
          <i className={`fas fa-user${item.connected ? '' : '-times'}`}></i>{' '}
          {item.name}
        </animated.span>
      ))}
    </div>
  );
}
